import { ifSelectorExist } from "./utils";

export const gravityFormsLogic = () => {
  // Function to remove the default selection and hide select elements based on their placeholder values
  const updateSelectElementsMasterminds = (placeholderText, hide = false, newSelectedValue) => {
    const selects = Array.from(document.querySelectorAll('select'));
    const checkTemplateName = document.querySelector('.contact-us__masterminds');
    if (ifSelectorExist(checkTemplateName)) {

      selects.forEach(select => {
        if (select.querySelector('option.gf_placeholder')?.textContent === placeholderText) {
          // Remove the default selection
          select.value = "";

          // Hide the select element if specified
          if (hide) {
            select.parentNode.parentNode.style.display = 'none';
          }

          // Set a new selected value, prevent changes, and add SVG icon
          if (newSelectedValue) {
            select.value = newSelectedValue;
            // Apply pointer-events: none to prevent interaction without disabling the field
            select.style.pointerEvents = 'none';
            select.classList.add('disabled')

            // Create the SVG icon as an HTML element
            const svgIcon = `
              <svg width="22" height="28" viewBox="0 0 22 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_254_1229)">
                  <path d="M17.0494 10.8348C16.6369 10.8348 16.2994 10.4981 16.2994 10.0866V6.78674C16.2994 3.86852 13.9216 1.49653 10.9962 1.49653C8.07092 1.49653 5.69315 3.86852 5.69315 6.78674V10.0866C5.69315 10.4981 5.35561 10.8348 4.94306 10.8348C4.53051 10.8348 4.19298 10.4981 4.19298 10.0866V6.78674C4.19298 3.04543 7.24582 0 10.9962 0C14.7467 0 17.7995 3.04543 17.7995 6.78674V10.0866C17.7995 10.4981 17.462 10.8348 17.0494 10.8348Z" fill="#CC2128"/>
                  <path d="M10.9962 20.989C10.5837 20.989 10.2462 20.6523 10.2462 20.2407V17.0905C10.2462 16.679 10.5837 16.3423 10.9962 16.3423C11.4088 16.3423 11.7463 16.679 11.7463 17.0905V20.2407C11.7463 20.6523 11.4088 20.989 10.9962 20.989Z" fill="#CC2128"/>
                  <path d="M18.3846 28.0001H3.61541C1.62018 28.0001 0 26.3838 0 24.3934V12.945C0 10.9546 1.62018 9.33838 3.61541 9.33838H18.3846C20.3798 9.33838 22 10.9546 22 12.945V24.3934C22 26.3838 20.3798 28.0001 18.3846 28.0001ZM3.61541 10.8349C2.45278 10.8349 1.50017 11.7777 1.50017 12.945V24.3934C1.50017 25.5532 2.44528 26.5035 3.61541 26.5035H18.3846C19.5472 26.5035 20.4998 25.5607 20.4998 24.3934V12.945C20.4998 11.7852 19.5547 10.8349 18.3846 10.8349H3.61541Z" fill="#CC2128"/>
                </g>
                <defs>
                  <clipPath id="clip0_254_1229">
                    <rect width="22" height="28" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            `;

            // Create a container div for styling and insert the SVG next to the select element
            const svgContainer = document.createElement('div');
            svgContainer.innerHTML = svgIcon;
            svgContainer.style.display = 'inline-block';
            // Append the SVG container after the select element
            select.parentNode.insertBefore(svgContainer, select.nextSibling);
          }
        }
      });
    }
  };



  updateSelectElementsMasterminds("Select Program", false, 'Fireproof Masterminds');

  // change title for mastermind form
  const mastermindFormTitle = document.querySelector('.contact-us__masterminds h2.gform_title');

  if (ifSelectorExist(mastermindFormTitle)) {
    mastermindFormTitle.textContent = "Reserve your spot";
  }

  
};